import Modal from '../components/Modal.vue';
import PageBottomCarouselApp from './components/PageBottomCarouselApp.vue';
import ProductDetailsApp from './components/ProductDetailsApp.vue';
import store from './state/store';
import UiButton from '../components/UiButton.vue';
import Vue from 'vue';

import BaseHttpService from '../services/BaseHttpService';
import ProductService from 'JS/services/ProductService';
import { BackInStockService } from './services/BackInStockService';
import { IProductDetailPageJson } from 'JS/types/PDP';

export function createApp(storeData: IProductDetailPageJson): { app: Vue, bottomCarousels: Vue } {
	Vue.component('UiButton', UiButton);
	Vue.component('Modal', Modal);

	const app = new Vue({
		store,
		render: h => h(ProductDetailsApp),
		provide: () => ({
			BackInStockService: new BackInStockService(new BaseHttpService()),
			productService: new ProductService()
		}),
	});

	const bottomCarousels = new Vue({
		store,
		render: h => h(PageBottomCarouselApp),
	});

	return { app, bottomCarousels };
}